module.exports = __webpack_public_path__ + "img/persona2.80f8d0dd.png";